import React from 'react';

import { FeedScreen } from '~/components/domain/posts/FeedScreen';

export default function LocalFeed() {
  return <FeedScreen feedType="local" />;
}
